import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import MyPreloader from "./components/common/Preloader";
const Top = lazy(() => import('./components/pages/Top'));

const AppRouter = () => {
  const [lang, setLang] = useState("");

  useEffect(() => {
    const language = (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language;
    const base_lang = language && (language.indexOf("ja")>=0) ? "" : "en";
    setLang(base_lang);
  }, []);

  return (
       <Suspense fallback={ <MyPreloader show={false} /> }>
        <Router>
          <Routes>
            <Route path="/en" element={<Top lang="en" type="fixed" setLang={setLang} />} />
            <Route path="*" element={<Top lang={lang} setLang={setLang} />} />
          </Routes>
        </Router>
       </Suspense>
  );
};


export default AppRouter;
